function isLocaleAwareInput({ input, output }) {
  if (input.localeAware) {
    output.true()
  } else {
    output.false()
  }
}

isLocaleAwareInput.outputs = ['true', 'false']
export default isLocaleAwareInput



// WEBPACK FOOTER //
// ./src/modules/client/actions/isLocaleAwareInput.js